import { Grid } from '@mui/material';
import { is_curatedMediaList_busy } from 'features/curatedMediaList/curatedMediaList-slice';
import React from 'react';
import { useSelector } from 'react-redux';
import LinearIndeterminate from './LinearIndeterminate';
import { is_curatedSeriesList_busy } from 'features/curatedSeriesList/curatedSeriesList-slice';
import { is_approvedMedia_busy } from 'features/approvedMedia/approvedMedia-slice';
import { is_approvalRequest_busy } from 'features/approvalRequest/approvalRequest-slice';
import { is_customerSettings_busy } from 'features/customerSettings/customerSettings-slice';
import { is_coherentScreen_busy } from 'features/coherentScreen/coherentScreen-slice';
import { is_processedMedia_busy } from 'features/processedMedia/processedMedia-slice';
import { is_mediaProcessJob_busy } from 'features/mediaProcessJob/mediaProcessJob-slice';
import { is_approvedSeries_busy } from 'features/approvedSeries/approvedSeries-slice';
import { is_systemSetting_busy } from 'features/systemSetting/systemSetting-slice';
import { is_profile_busy } from 'features/profile/profile-slice';

export default function Busy() {
    const curatedMediaList_busy = useSelector(is_curatedMediaList_busy);
    const curatedSeriesList_busy = useSelector(is_curatedSeriesList_busy);
    const approvedSeries_busy = useSelector(is_approvedSeries_busy);
    const approvedMedia_busy = useSelector(is_approvedMedia_busy)
    const systemSchedule_busy = useSelector(is_systemSetting_busy);
    const profile_busy = useSelector(is_profile_busy);

    const approvalRequest_busy = useSelector(is_approvalRequest_busy)
    const processedMedia_busy = useSelector(is_processedMedia_busy);
    const coherentScreen_busy = useSelector(is_coherentScreen_busy);
    const mediaProcessingJobs_busy = useSelector(is_mediaProcessJob_busy)
    const customerSettings_busy = useSelector(is_customerSettings_busy)
    const busy = approvalRequest_busy ||
        approvedMedia_busy ||
        systemSchedule_busy ||
        mediaProcessingJobs_busy ||
        profile_busy ||
        processedMedia_busy ||
        curatedMediaList_busy ||
        approvedSeries_busy ||
        coherentScreen_busy ||
        customerSettings_busy ||
        curatedSeriesList_busy;

    return (
        <Grid item xs={12}>
            <LinearIndeterminate visible={busy} />
        </Grid>
    )
}